module.exports = __webpack_public_path__ + "img/aochangzhang.cf0b17df.jpg";